import { ILichSuYteRequest } from '../models/request/hoc-sinh/ILichSuYteRequest';
import { apiGuestClient } from './apiGuestClient';

export const API_END_POINT = "lich-su-xuong-phong-y-te";

export const lichSuXuongPhongYTeApi = {
    selectByHocSinh: (ts_hocsinh_id: number) => apiGuestClient.get(`hoc-sinh/${ts_hocsinh_id}/lich-su-xuong-phong-y-te`),
    selectAll: (dm_cocso_id: number, nam_hoc: string) => apiGuestClient.get(`${API_END_POINT}/co-so/${dm_cocso_id}/nam-hoc/${nam_hoc}`),
    selectById: (id: number) => apiGuestClient.get(`${API_END_POINT}/${id}`),
    insert: (request: ILichSuYteRequest) => apiGuestClient.post(`${API_END_POINT}`, request),
    update: (request: ILichSuYteRequest) => apiGuestClient.put(`${API_END_POINT}/${request.id}`, request),
    delete: (id: number) => apiGuestClient.delete(`${API_END_POINT}/${id}`),
};
